import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {
  errorMessage?: string
} & Status

const initialState = {
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.VERIFY_ABSHER_FOR_UPDATE_MOBILE_ASYNC,
    Actions.VERIFY_ABSHER_FOR_UPDATE_MOBILE_SUCCESS,
    Actions.VERIFY_ABSHER_FOR_UPDATE_MOBILE_FAIL,
    {},
    { error?: { message: string } }
  >,
): State => {
  switch (action.type) {
    case Actions.VERIFY_ABSHER_FOR_UPDATE_MOBILE_ASYNC:
    case Actions.VERIFY_ABSHER_FOR_UPDATE_MOBILE_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.VERIFY_ABSHER_FOR_UPDATE_MOBILE_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error?.message || '',
      }
    }
    default:
      return state
  }
}
